import {Injectable} from "@angular/core";
import {ContractsRequestDto, ContractsRuntimeDto} from "../../cross/contracts/types/contracts.types";
import {BehaviorSubject, Subject} from "rxjs";
import {ContractApiService} from "../../cross/contracts/api/contract-api.service";
import {MessageHelper} from "../../core/helper/message-helper";
import {AppMessageService} from "../../core/service/app-message.service";

@Injectable({
  providedIn: 'root',
})
export class DashboardService {

  dashboardSubject: Subject<ContractsRuntimeDto> = new Subject<ContractsRuntimeDto>();
  requestSubject: Subject<ContractsRequestDto> = new Subject<ContractsRequestDto>();


  constructor(protected contractsApiService: ContractApiService, protected messageService: AppMessageService) {

    this.requestSubject.subscribe((value: ContractsRequestDto) => {
      this.listContracts(value as ContractsRequestDto);
    });

  }


  public changeRequest(request: ContractsRequestDto) {
    this.requestSubject.next(request);
  }

  public listContracts(request: ContractsRequestDto) {

    this.contractsApiService.list(request).subscribe((value: ContractsRuntimeDto) => {
      this.dashboardSubject.next(value);
    }, error =>  {
      MessageHelper.showErrorMessage(error.error.data, this.messageService);
    });

  }

}
